import Dropdown from "Components/Dropdown";
import styled from "styled-components";
import { MainContainerTheme, mobileSize } from "Themes/Metrics";

export const MainContainer = styled(MainContainerTheme)`
  padding-top: 50px;
  width: 50%;
  @media ${mobileSize.large} {
    width: 100%;
    padding-top: 50px;
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  background-color: white;
  border-radius: 10px;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const FormContainer = styled.div`
  flex: 3;
  border: ${props =>
    props.success
      ? "solid 2px green"
      : props.error
      ? "solid 2px red"
      : "solid 2px lightgray"};
  border-radius: 5px;
  padding: 20px;
  flex-wrap: wrap;
  @media ${mobileSize.large} {
    border: none;
  }
`;

export const NavContainer = styled.div`
  flex: 1;
  margin-right: 20px;
  @media ${mobileSize.large} {
    display: none;
  }
`;

export const NavSidepanel = styled.div`
  border: solid 2px lightgray;
  border-radius: 5px;
`;

export const NavItem = styled.div`
  padding: 10px;
  cursor: pointer;
  background-color: ${props => (props.selectedNavItem ? "white" : "lightgray")}
  &:hover {
    text-decoration: underline;
  }
`;

export const DropdownContainer = styled.div`
  display: none;
  @media ${mobileSize.large} {
    display: block;
  }
`;

export const DropdownStyled = styled(Dropdown)``;
